import { render, staticRenderFns } from "./AdwordsVisualsComponent.vue?vue&type=template&id=01ca2516"
import script from "./AdwordsVisualsComponent.vue?vue&type=script&lang=js"
export * from "./AdwordsVisualsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports